import api from '@/lib/api'

// Custom hooks to run side-effects when
// certain API endpoints are requested
const hooks = [
	{
		match: ({ endpoint }) => /^\/submissions\?.*status=new/.test(endpoint),
		actions: ['getPendingSubmissions']
	},
	{
		match: ({ endpoint }) => /^\/campaigns\/\d+\/active$/.test(endpoint),
		actions: ['getPendingSubmissions']
	}
]

// Run any matched API hook
const runHooks = ctx => ({ req, res }) => {
	// Find hook matching payload
	const hook = hooks.find(h => h.match(req))
	if (hook) {
		// If hook is found, dispatch all actions asynchronously
		for (const action of hook.actions) ctx.dispatch(action)
	}
	return res
}

// API request with chained hooks
const request = (ctx, payload) => api(payload).then(runHooks(ctx))

/**
 * Vuex starts here
 */

const state = {
	pendingSubmissions: 0
}

const mutations = {
	set(state, { key, value }) {
		state[key] = value
	}
}

const actions = {
	// Map API calls to Vuex actions
	get: (ctx, payload) => request(ctx, payload),
	post: (ctx, payload) => request(ctx, { method: 'POST', ...payload }),
	put: (ctx, payload) => request(ctx, { method: 'PUT', ...payload }),
	patch: (ctx, payload) => request(ctx, { method: 'PATCH', ...payload }),
	delete: (ctx, payload) => request(ctx, { method: 'DELETE', ...payload }),

	// Custom actions to use in API hooks

	getPendingSubmissions({ commit, dispatch }) {
		const endpoint = '/submissions/countPending'
		dispatch('get', { endpoint })
			.then(res => res.json())
			.then(value => {
				// Save count of pending submissions to store
				const key = 'pendingSubmissions'
				commit('set', { key, value })
			})
			.catch(() => {
				// Failed to fetch, show toast
				dispatch(
					'toast/push',
					{
						message: 'Failed to update pending submission count.',
						severity: 'warning'
					},
					{ root: true }
				)
			})
	}
}

export default {
	state,
	mutations,
	actions,
	namespaced: true
}
